import Vue from 'vue'
import Router from 'vue-router'
import routes from './routes'
import store from '@/store'
import { sync } from 'vuex-router-sync'

Vue.use(Router)

const router = new Router({
    mode: 'history',
    routes: routes
})

sync(store, router)

router.beforeEach((to, from, next) => {

    const components = router.getMatchedComponents({ ...to })

    if (components.length)
    {
        if (components && components[0] && typeof components[0] == 'function')
        {
            setTimeout(() => {
                components[0]().then(component => {
                    try {
                        router.app.setLayout(component.default.layout || '')
                    } catch(e) {}
                    next()
                })
            }, 10)
        } else {
            try {
                router.app.setLayout(components[0].layout || '')
            } catch(e) { }
            next()
        }


    } else {
        try {
            router.app.setLayout('')
        } catch(e) {}
        next()
    }

})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js